<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">进销存设置</span>
      <div class="flex">
        <HSwitch v-model="jxcModule" small></HSwitch>
        <span class="margin-left">启用进销存模块</span>
      </div>
    </div>
    <Tabs :datas="tabDatas" v-model="selected"></Tabs>
    <div class="h-panel-body padding">
      <component :is="selected"></component>
    </div>
  </app-content>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2020 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : financial</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2022/6/13 15:13</li>
 * <li>@author     : ____′↘TangSheng</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import {mapState} from "vuex";
import LinkJxcAccountSet from './jxc/LinkJxcAccountSet'
import SetJxcParam from './jxc/SetJxcParam'
import MaterialArchive from './jxc/MaterialArchive'
import SupplierArchive from './jxc/SupplierArchive'
import OrderManage from './jxc/OrderManage'

export default {
  name: "JxcSetting",
  components: {LinkJxcAccountSet, SetJxcParam, MaterialArchive, SupplierArchive, OrderManage},
  data() {
    return {
      tabDatas: [
        {
          title: '关联账套',
          key: 'LinkJxcAccountSet'
        }, {
          title: '科目映射',
          key: 'SetJxcParam'
        }, {
          title: '物料档案',
          key: 'MaterialArchive'
        }, {
          title: '供应商档案',
          key: 'SupplierArchive'
        }, {
          title: '单据管理',
          key: 'OrderManage'
        }],
      selected: 'LinkJxcAccountSet',
    };
  },
  computed: {
    ...mapState(["currentAccountSets"]),
    jxcModule: {
      get() {
        return !!this.currentAccountSets.jxcModule;
      },
      set(val) {
        //开关状态以服务端/仓库为准，失败时给出提示（getter 会自动回滚显示）
        this.$api.setting.accountSets.update({id: this.currentAccountSets.id, jxcModule: val ? 1 : 0}).then(() => {
          this.$store.dispatch('init');
        }).catch(() => {
          this.$Message.error('进销存模块启用状态更新失败');
          this.$forceUpdate();
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>

</style>
